import Select from "../components/Select";
import RadioGroup from "../components/RadioGroup";
import PrimaryButton from "../components/Submit";
import FormHeader from "../components/FormHeader";

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function AdditionalPersonalDetails(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Additional personal details" />
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        <Select
          label="Nationality"
          placeholder="Select your Nationality"
          className="select-full"
          showFlags={true}
          options={[
            { key: "us", value: "United States" },
            { key: "gb", value: "United Kingdom" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          validatemessage={""}
        />
        <RadioGroup
          label="Do you have another nationality?"
          name="anotherNationality"
          options={[
            { key: "Yes", value: "Yes" },
            { key: "No", value: "No" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          value=""
          validatemessage={""}
        />
        <RadioGroup
          label="Are you a citizen of the United States?"
          name="usCitizen"
          options={[
            { key: "yes", value: "Yes" },
            { key: "no", value: "No" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          value="no"
        />
        <RadioGroup
          label="Are you a tax resident anywhere else?"
          name="taxResident"
          options={[
            { key: "yes", value: "Yes" },
            { key: "no", value: "No" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
          value="no"
        />
        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default AdditionalPersonalDetails;
